export enum MetricId {
  NUMBER_OF_UNPAID_OPERATION = 'number_of_unpaid_operations',
  RISK_SCORE = 'risk_score',
}
